module.exports = __webpack_public_path__ + "static/media/link_expired.6c80cd7c.svg";